import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useSession } from '../../state/session'
import useRoutes from '../../state/useRoutes'

import { InsightsPageCertificates } from './InsightsPageCertificates'
import { InsightsPageFinishedLearningItems } from './InsightsPageFinishedLearningItems'
import { InsightsPageLearningInvestment } from './InsightsPageLearningInvestment'

import styles from './InsightsPage.module.scss'

/**********************************************************************
 * InsightsPage
 **********************************************************************/
export default React.memo(function InsightsPage() {
  const { user } = useSession()

  return (
    <article className={styles.InsightsPage}>
      <InsightsPageLearningInvestment userUuid={user?.uuid} />

      <InsightsPageCertificates userUuid={user?.uuid} />

      <InsightsPageFinishedLearningItems userUuid={user?.uuid} />
    </article>
  )
})

export function InsightsPageBreadcrumb() {
  const { t } = useTranslation()
  const routes = useRoutes()
  return <Link to={routes.insights.url({})}>{t('insights.page title')}</Link>
}
